export const VIDEO_COMMENT_RESET = Symbol('VIDEO_COMMENT_RESET');
export const VIDEO_COMMENT_FETCH_REQUEST = Symbol('VIDEO_COMMENT_FETCH_REQUEST');
export const VIDEO_COMMENT_FETCH_SUCCESS = Symbol('VIDEO_COMMENT_FETCH_SUCCESS');
export const VIDEO_COMMENT_FETCH_ERROR = Symbol('VIDEO_COMMENT_FETCH_ERROR');
export const VIDEO_COMMENT_ADD_REQUEST = Symbol('VIDEO_COMMENT_ADD_REQUEST');
export const VIDEO_COMMENT_ADD_SUCCESS = Symbol('VIDEO_COMMENT_ADD_SUCCESS');
export const VIDEO_COMMENT_ADD_ERROR = Symbol('VIDEO_COMMENT_ADD_ERROR');
export const VIDEO_COMMENT_REMOVE_REQUEST = Symbol('VIDEO_COMMENT_REMOVE_REQUEST');
export const VIDEO_COMMENT_REMOVE_FROM_STORE = Symbol('VIDEO_COMMENT_REMOVE_FROM_STORE');

export const videoCommentAddRequestAction = (videoId, name, email, content) => ({
  type: VIDEO_COMMENT_ADD_REQUEST,
  payload: {
    video: { id: videoId },
    user: { name, email },
    content,
  },
});

export const videoCommentAddSuccessAction = () => ({
  type: VIDEO_COMMENT_ADD_SUCCESS,
  payload: {},
});

export const videoCommentAddErrorAction = () => ({
  type: VIDEO_COMMENT_ADD_ERROR,
  payload: {},
});

export const videoCommentsFetchRequestAction = (videoId) => ({
  type: VIDEO_COMMENT_FETCH_REQUEST,
  payload: {
    videoId,
  },
});

export const videoCommentsFetchSuccessAction = (comments, total) => ({
  type: VIDEO_COMMENT_FETCH_SUCCESS,
  payload: {
    comments,
    total,
  },
});

export const videoCommentsFetchErrorAction = () => ({
  type: VIDEO_COMMENT_FETCH_ERROR,
  payload: {},
});

export const videoCommentsResetAction = () => ({ type: VIDEO_COMMENT_RESET });

/**
 *
 * @param {string} videoId
 * @param {number} commentId
 * @return {{type: symbol, payload: {videoId: string, commentId: number}}}
 */
export const videoCommentRemoveRequestAction = (videoId, commentId) => ({
  type: VIDEO_COMMENT_REMOVE_REQUEST,
  payload: { videoId, commentId },
});

/**
 * @param {number} commentId
 * @return {{type: symbol, payload: {commentId: number}}}
 */
export const videoCommentRemoveFromStoreAction = (commentId) => ({
  type: VIDEO_COMMENT_REMOVE_FROM_STORE,
  payload: { commentId },
});
